export default __webpack_public_path__ + "static/media/music.64740ad6.mpeg";